<template>
<div class="chapter">
<div class="inner_page">
<h2 class="pn"><a id="page_6"></a><a id="page_7"></a>Part I</h2>
<h2 class="pt">First Person</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Part1.vue?36990200